import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import * as styles from "./billing-picker.module.css";

export const BillingPicker = memo(function BillingPicker({
  mode,
  setMode,
  pctLabel,
  pctValue,
  pctSetValue,
  pctSuffix,
  fixedLabel,
  fixedValue,
  fixedSetValue,
  fixedSuffix,
}: {
  mode: "percentage" | "fixed";
  setMode: (v: "percentage" | "fixed") => void;
  pctLabel: string;
  pctValue: string;
  pctSetValue: (v: string) => void;
  pctSuffix: string;
  fixedLabel: string;
  fixedValue: string;
  fixedSetValue: (v: string) => void;
  fixedSuffix: string;
}) {
  const isPct = mode === "percentage";
  return (
    <Flex dir="column" gap="lg" pt="sm">
      <Flex
        align="center"
        className={isPct ? styles.optionSelected : styles.optionUnselected}
        gap="lg"
        onClick={() => setMode("percentage")}
      >
        <span className={isPct ? styles.radioOuterSelected : styles.radioOuter}>
          {isPct && <span className={styles.radioInner} />}
        </span>
        <Flex dir="column" gap="xxs" grow="1">
          <Text fontSize="xs" fontWeight="semibold">
            {pctLabel}
          </Text>
        </Flex>
        <Flex onClick={(e: React.MouseEvent) => e.stopPropagation()} shrink={0}>
          <RedoTextInput
            IconTrailing={() => <Text as="span">{pctSuffix}</Text>}
            inputTypeHint="number"
            min={0}
            placeholder="0"
            setValue={pctSetValue}
            size="sm"
            state={isPct ? "default" : "disabled"}
            step={1}
            value={pctValue}
          />
        </Flex>
      </Flex>
      <Flex
        align="center"
        className={!isPct ? styles.optionSelected : styles.optionUnselected}
        gap="lg"
        onClick={() => setMode("fixed")}
      >
        <span
          className={!isPct ? styles.radioOuterSelected : styles.radioOuter}
        >
          {!isPct && <span className={styles.radioInner} />}
        </span>
        <Flex dir="column" gap="xxs" grow="1">
          <Text fontSize="xs" fontWeight="semibold">
            {fixedLabel}
          </Text>
        </Flex>
        <Flex onClick={(e: React.MouseEvent) => e.stopPropagation()} shrink={0}>
          <RedoTextInput
            IconTrailing={() => <Text as="span">{fixedSuffix}</Text>}
            inputTypeHint="number"
            min={0}
            placeholder="0.00"
            setValue={fixedSetValue}
            size="sm"
            state={!isPct ? "default" : "disabled"}
            step={0.01}
            value={fixedValue}
          />
        </Flex>
      </Flex>
    </Flex>
  );
});
